var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDimInvestimenti(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 66 76.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: none;\n        stroke: #fff;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 2.7px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.4,39.8h27.5M20.6,66.4H2.7c-.8,0-1.4-.7-1.4-1.5V16.1L15.1,1.4h34.4c.8,0,1.4.7,1.4,1.5v34M15.1,1.4v13.3c0,.8-.6,1.5-1.4,1.5H1.4M64.7,47.9v22.2c0,2.9-4.3,5.2-9.6,5.2s-9.6-2.3-9.6-5.2v-22.2M64.7,47.9c0,2.9-4.3,5.2-9.6,5.2s-9.6-2.3-9.6-5.2,4.3-5.2,9.6-5.2,9.6,2.3,9.6,5.2ZM64.7,55.3c0,2.9-4.3,5.2-9.6,5.2s-9.6-2.3-9.6-5.2M64.7,62.7c0,2.9-4.3,5.2-9.6,5.2s-9.6-2.3-9.6-5.2M45.4,70.1c0,2.9-4.3,5.2-9.6,5.2s-9.6-2.3-9.6-5.2v-7.4M31.6,13.2h8.3v8.9M12.4,30.9l8.3-8.9,5.5,5.9,13.8-14.8M45.4,62.7c0,2.9-4.3,5.2-9.6,5.2s-9.6-2.3-9.6-5.2,4.3-5.2,9.6-5.2,9.6,2.3,9.6,5.2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14.5,48.7h-1.3M38.2,48.7h-1.3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDimInvestimenti);
export default __webpack_public_path__ + "static/media/dim-investimenti.69f8f80434ed3208629a9f32be9d5266.svg";
export { ForwardRef as ReactComponent };